import { RepositoryFactory } from '@/api/RepositoryFactory'
import {
  SET_HARDWARE,
  SET_LOADING,
  SET_TTN_BIDS,
  SET_TTN_RESPONSES,
  SET_UNKNOWN_DOCS,
} from './actions/hardware'

const Hardware = RepositoryFactory.get('hardware')
const Doc = RepositoryFactory.get('doc')
const flag = true

export default {
  namespaced: true,
  state: {
    unknownDocs: [],
    pagination: {},
    loading: true,
    current: null,
    hardware_public_id: '',
    hardware: [],
    loadingHardware: false,
    ttnBids: [],
    loadingBids: false,
    ttnResponses: [],
    loadingResponses: false,
  },
  getters: {
    unknownDocs: state => state.unknownDocs,
    pagination: state => state.pagination,
    current: state => state.current,
    hardware_public_id: state => state.hardware_public_id,
    hardwareList: state => state.hardware,
    ttnBids: state => state.ttnBids,
    ttnResponses: state => state.ttnResponses,
    getLoading: state => type => state[`loading${type || ''}`],
  },
  actions: {
    fetchUnknownFiles({ commit, dispatch, state }, { page, sort, next }) {
      commit(SET_LOADING, { flag })
      const hardware_public_id = state.hardware_public_id

      Hardware.getUnknownDocs({ page, sort, hardware_public_id })
        .then(async ({ data }) => {
          await commit(SET_UNKNOWN_DOCS, data)

          if (next && data?.items?.length) {
            dispatch('generateCurrent', data.items[0])
          }
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
    fetchHardware({ commit }) {
      const type = 'Hardware'

      commit(SET_LOADING, { flag, type })
      Hardware.getHardware()
        .then(res => commit(SET_HARDWARE, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { type }))
    },
    fetchTtnBids({ commit }, settings = {}) {
      const type = 'Bids'

      commit(SET_LOADING, { flag, type })

      return Hardware.getTtnBids(settings)
        .then(async res => {
          await commit(SET_TTN_BIDS, res.data)
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { type }))
    },
    fetchTtnResponses({ commit }, settings = {}) {
      const type = 'Responses'

      commit(SET_LOADING, { flag, type })
      Hardware.getTtnResponses(settings)
        .then(res => commit(SET_TTN_RESPONSES, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { type }))
    },
    saveHardwareTTN({ commit, dispatch, state }, data) {
      commit(SET_LOADING, { flag })
      const requestData = { ...data, files: state.current.files }

      Hardware.ttnInput(requestData)
        .then(res => {
          if (res.status === 200) {
            commit('setCurrent')
            dispatch('fetchUnknownFiles', { sort: localStorage.getItem('report_sort_mode'), next: true })
          }
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
    generateCurrent({ commit }, doc) {
      const files = doc?.files ? Hardware.generateImgUrls(doc.files) : []

      commit('setCurrent', { ...doc, files })
    },
    /** Additional actions **/
    generateZipUrl(context, id) {
      return Doc.getZipUrl(id)
    },
    getLastEdited() {
      return Doc.getLastEdited()
        .then(({ data }) => data)
        .catch(e => console.log(e))
    },
    makeDocSorted({ commit, dispatch }, { id, data }) {
      commit(SET_LOADING, { flag })

      return Doc.update(id, data)
        .then(res => {
          if (res.status === 200) {
            commit('setCurrent')
            dispatch('fetchUnknownFiles', { sort: localStorage.getItem('report_sort_mode'), next: true })
          }
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
  },
  mutations: {
    [SET_LOADING](state, obj = {}) {
      const { flag, type } = obj

      state[`loading${type || ''}`] = Boolean(flag)
    },
    [SET_HARDWARE](state, data) {
      state.hardware = data
    },
    [SET_UNKNOWN_DOCS](state, data) {
      const { items, _meta } = data

      state.pagination = _meta
      state.unknownDocs = items
    },
    [SET_TTN_BIDS](state, data) {
      state.ttnBids = data
    },
    [SET_TTN_RESPONSES](state, data) {
      state.ttnResponses = data
    },
    setCurrent: (state, current = null) => {
      state.current = current
    },
    setVariant: (state, { id, variant }) => {
      const index = state.current.files.findIndex(file => file.id === id)

      if (index !== -1) {
        const newFile = { ...state.current.files[index], variant }

        state.current.files.splice(index, 1, newFile)
      }
    },
    setHardwareId: (state, hardware_public_id = '') => {
      state.hardware_public_id = hardware_public_id
    },
  },
}
